import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { breakpoints } from '../../core/constants';

gsap.registerPlugin(ScrollTrigger);

export class WorkScrollJack {
    constructor(workPanes) {
        if (!workPanes) return;

        this.workPanes = workPanes;
        this.animations = [];

        if (window.matchMedia(`(min-width: ${breakpoints.lg}px)`).matches) {
            this.init();
        }
    }

    init() {
        this.initAnimation(this.workPanes);
        this.registerEvents();
    }

    registerEvents() {
        window.addEventListener('resize', () => {
            this.resetAnimations();
            this.initAnimation(this.workPanes);
        });
    }

    initAnimation(elements) {
        elements.forEach((pane) => {
            const element = pane.querySelector('.grid--content');
            this.createAnimation(element);
        });
    }

    createAnimation(element) {
        const translateX = this.totalWidth(element) - window.innerWidth;

        const animation = gsap.to(element, {
            x: translateX * -1,
            scrollTrigger: {
                trigger: element,
                start: 'top top',
                end: `${translateX * 0.5} top`,
                scrub: 1,
                pin: true,
                markers: false,
                preventOverlaps: true,
                onLeave: function(e) {
                    if (window.marqueeAnimationScrolltriggers) {
                        [...window.marqueeAnimationScrolltriggers].forEach((animation) => {
                            animation.scrollTrigger.refresh();
                        });
                    }
                },
            },
        });

        this.animations.push(animation);
    }

    resetAnimations() {
        // Kill all existing animations and ScrollTriggers
        this.animations.forEach((animation) => {
            animation.scrollTrigger.kill();
            animation.kill();
        });
        this.animations = [];

        // Refresh ScrollTrigger to clear all state
        ScrollTrigger.clearMatchMedia();
        ScrollTrigger.refresh();
    }

    totalWidth(parentElement) {
        const childElements = parentElement.children;

        let totalWidth = 0;
        for (const child of childElements) {
            totalWidth += child.offsetWidth;
        }
        return totalWidth;
    }
}
